// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-json"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 10V7L15 2H4L4 10M4 22H20M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 19H4.8C4.91046 19 5 18.9041 5 18.7857V13H3.66667M9.5 13H7.75C7.61193 13 7.5 13.1919 7.5 13.4286V15.5714C7.5 15.8081 7.61193 16 7.75 16H9.25C9.38807 16 9.5 16.1919 9.5 16.4286V18.5714C9.5 18.8081 9.38807 19 9.25 19H7.5M17.5 19V13H20.1667C20.3508 13 20.5 13.1919 20.5 13.4286V19M12 13.4286L12 18.5714C12 18.8081 12.1679 19 12.375 19H14.625C14.8321 19 15 18.8081 15 18.5714V13.4286C15 13.1919 14.8321 13 14.625 13L12.375 13C12.1679 13 12 13.1919 12 13.4286Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileJsonIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-json',
    ref,
    icon: element,
  },
));

FileJsonIcon.displayName = 'FileJsonIcon';

export default FileJsonIcon;
